import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type ButtonVariant =
  | 'default'
  | 'destructive'
  | 'outline'
  | 'secondary'
  | 'ghost';

export type ButtonSize =
  | 'default'
  | 'sm'
  | 'lg'
  | 'icon';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html'
})
export class ButtonComponent {
  @Input() renderAs: 'button' | 'a' = 'button';
  @Input() variant: ButtonVariant = 'default';
  @Input() size: ButtonSize = 'default';
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() href?: string;

  get classes(): string[] {
    return [
      BASE_CLASSES,
      VARIANT_CLASSES[this.variant],
      SIZE_CLASSES[this.size]
    ];
  }
}

/* ---------------- constants ---------------- */

const BASE_CLASSES =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md ' +
  'text-sm font-medium focus-visible:outline-none focus-visible:ring-1 ' +
  'focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 ' +
  '[&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 ' +
  'hover-elevate active-elevate-2';

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  default:
    'bg-primary text-primary-foreground border border-primary-border',
  destructive:
    'bg-destructive text-destructive-foreground border border-destructive-border',
  outline:
    'border [border-color:var(--button-outline)] shadow-xs active:shadow-none',
  secondary:
    'border bg-secondary text-secondary-foreground border-secondary-border',
  ghost:
    'border border-transparent'
};

const SIZE_CLASSES: Record<ButtonSize, string> = {
  default: 'min-h-9 px-4 py-2',
  sm: 'min-h-8 rounded-md px-3 text-xs',
  lg: 'min-h-10 rounded-md px-8',
  icon: 'h-9 w-9'
};
